import React from "react";

import "./ACBadge.less";

type ACBadgeType = "beta" | "preview" | "alert";

type ACBadgeProps = {
  type: ACBadgeType;
  dot?: true;
  content?: React.ReactNode;
};

const ACBadge = ({ type, dot, content }: ACBadgeProps) => {
  return (
    <span
      className={`ac-badge ${
        dot ? `ac-badge-dot ac-badge-dot-${type}` : `ac-badge-content-${type}`
      }`}
    >
      {!dot && content}
    </span>
  );
};

export default ACBadge;
